import {
  ModuleFlagsSchema,
  IaFlagsSchema,
  IntegrationFlagsSchema,
  RedFlagsSchema,
  type FeatureKey,
} from '@condo/contracts';
import { FlagRow } from './flag-row.js';
import { GROUP_LABELS, GROUP_DESCRIPTIONS, type FlagGroup } from './constants.js';
import type { FlagForm } from './use-flag-form.js';

const GROUP_KEYS: Record<FlagGroup, readonly string[]> = {
  modules: Object.keys(ModuleFlagsSchema.shape),
  ia: Object.keys(IaFlagsSchema.shape),
  integrations: Object.keys(IntegrationFlagsSchema.shape),
  red: Object.keys(RedFlagsSchema.shape),
};

interface Props {
  group: FlagGroup;
  form: FlagForm;
}

export function FlagSection({ group, form }: Props) {
  return (
    <section className="mb-8 last:mb-0">
      <header className="mb-3">
        <h2 className="text-xs font-semibold uppercase tracking-[0.12em] text-[var(--color-ink-muted)]">
          {GROUP_LABELS[group]}
        </h2>
        <p className="mt-1 text-xs text-[var(--color-ink-muted)]">
          {GROUP_DESCRIPTIONS[group]}
        </p>
      </header>
      <div className="rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper)]">
        {GROUP_KEYS[group].map((name) => (
          <FlagRow
            key={name}
            flag={`${group}.${name}` as FeatureKey}
            form={form}
          />
        ))}
      </div>
    </section>
  );
}
